import React from 'react'
import { Panel, TextFieldIcon, TextDetail } from '../../_components'
import { FaAddressCard, FaHourglassEnd,} from 'react-icons/fa'

export default function PreviewForm( { handleChange, handleBlur, values, signing } ) {
  //console.log( values )

  return (
    <>
    <Panel label="Applicant Details">
        <div className="grid grid-cols-2 gap-2 items-center">
          {values.category === "Individual" && 
            <>
            <TextDetail label="Category" val={values.category} />
            <TextDetail label="Given Name/ First Name" val={values.given_name} />
            <TextDetail label="Surname" val={values.surname} />
            <TextDetail label="Other Name" val={values.middle_name} />
            <TextDetail label="Nationality" val={values.nationality} />
            <TextDetail label="Taxpayer Identification Number" val={values.tin} />
            </>
          }

          {values.category === "Company" &&
            <>
              <TextDetail label="Category" val={values.category} />
              <TextDetail label="Trading Name" val={values.trading_name} />
              <TextDetail label="Contact First Name" val={values.contact_first_name} />
              <TextDetail label="Contact Last Name" val={values.contact_last_name} />
              <TextDetail label="Other Name" val={values.contact_middle_name} />

              <TextDetail label="TIN" val={values.tin} />
            </>
          }
        </div>

        {/* <div className="grid grid-cols-1 gap-2 md:grid-cols-3 lg:grid-cols-3">
          <TextFieldIcon 
            name="preview_category"
            handleChange={handleChange}
            handleBlur={handleBlur}
            value={values.category}
            iconComponent={<FaAddressCard color={`#AFC836`} />} 
            label="Applicant Category"
            required={false}
            disabled={true}
            question="Applicant Category" 
          />
        </div> */}
      </Panel>

      <Panel label="Applicant Particulars">
        <div className="grid grid-cols-2 gap-2 items-center">
          <TextDetail label="Certification Level" val={values.certification_level} />
          <TextDetail label="Purpose of Application" val={values.application_purpose} />
          <TextDetail label="Type of service" val={values.service_type} />
          <TextDetail label="Services" val={values.service_name} />
          <TextDetail label="Website" val={values.website} />
          <TextDetail label="Annual Turnover/Income for the Previous Year" val={values.annual_turnover} />
          <TextDetail label="Membership to I.T Professional bodies" val={values.membership} />
          {values.category === "Company" &&
            <>
              <TextDetail label="Number of Employees ( MALES )" val={values.no_males} />
              <TextDetail label="Number of Employees ( FEMALES )" val={values.no_females} />
            </>
          }
        </div> 
      </Panel>

      <Panel label="Location Particulars">
        <div className="grid grid-cols-2 gap-2 items-center">
          <TextDetail label="District" val={values.category} />
          <TextDetail label="County" val={values.county} />
          <TextDetail label="Subcounty" val={values.subcounty} />
          <TextDetail label="Parish" val={values.parish} />
          <TextDetail label="Village" val={values.village} />
        </div> 
      </Panel>
    </>
  )
}
